import React from 'react';

import moment from 'moment';

export const formFields = {


  ro: {
    key: 'ro',
    label: 'RO ',
    placeholder: '',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'text',
  },
  roStatus: {
    key: 'roStatus',
    label: 'Status ',
    placeholder: '',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.', 
    valueKey: 'id',
    textKey: 'text',
  },
}

export const optionsData = {
  columns: [
    { id: 1, name: 'id', label: 'Goal ID', sortable: false, type: 'number', expand: true }, 
    { id: 2, name: 'name', label: 'Goals Name', sortable: true, type: 'string', component: (row) => <div title={row.name}>{row.name.length > 58 ? `${row.name.slice(0,58)} ...`: row.name }</div> },
    { id: 3, name: 'primaryGoal', label: 'Primary Goal', sortable: true, type: 'number' },
    { id: 4, name: 'primaryGoalValue', label: 'Primary Goal Value', sortable: true, type: 'number', component: (row) => row.primaryGoalValue ? row.primaryGoalValue : "-" },
    { id: 5, name: 'MappedCampCount', label: 'Mapped Campaigns', sortable: false, type: 'number', component: (row) => row.MappedCampCount ? row.MappedCampCount : "0"  },
    { id: 6, name: 'sDate', label: 'Created On', sortable: true, type: 'string', component: (row) => row.sDate != undefined ? moment(row.sDate).format("YYYY-MM-DD") : "-" },
    { id: 7, name: 'lastUpdate', label: 'Last Updated On', sortable: true, type: 'string', component: (row) => row.lastUpdate != undefined ? moment(row.lastUpdate).format("YYYY-MM-DD") : "-" },
    { id: 8, name: 'status', label: 'Status', sortable: false, type: 'string', component: (row) => row.status === 1 ? <p className='badge bg-label-success'>Active</p> : <p className='badge bg-label-danger'>Inactive</p> },
  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-pencil',
    tooltip: 'Edit'
  },
  {
    type: 'view',
    text: '',
    icon: 'mdi mdi-eye',
    tooltip: 'View'
  }
  ],
  recActive: true,
  status: {
    key: 'status',
    active: '1',
    activeIcon: 'mdi mdi-checkbox-marked',
    inActiveIcon: 'mdi mdi-close-box',
    // confirmation: true,
    // activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    // inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  },
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    sortBy: 'name',
    sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  },
  CSVDownload: {
    type: 'goalList',
    showCSVButton: true,
    buttonName: 'Download Goal List',
    saveFileName: 'goal_list'
  }
};

export const mappedCampaignOptions = {
  columns: [
    { id: 1, name: 'campaignId', label: 'Camp ID', sortable: false, type: 'number', expand: true }, 
    { id: 2, name: 'name', label: 'Campaign Name', sortable: true, type: 'string', component: (row) => <div title={row.name}>{row.name.length > 58 ? `${row.name.slice(0,58)} ...`: row.name }</div> },
    // { id: 3, name: 'primaryGoal', label: 'DSP Platforms', sortable: true, type: 'number' },
    // { id: 4, name: 'primaryGoalValue', label: 'Campaign Daily Budget', sortable: true, type: 'number', component: (row) => row.primaryGoalValue ? row.primaryGoalValue : "-" },
    { id: 6, name: 'sDate', label: 'Start Date', sortable: true, type: 'string', component: (row) => row.sDate != undefined ? moment(row.sDate).format("YYYY-MM-DD") : "-" },
    { id: 7, name: 'eDate', label: 'End Date', sortable: true, type: 'string', component: (row) => row.eDate != undefined ? moment(row.eDate).format("YYYY-MM-DD") : "-" },
    { id: 8, name: 'status', label: 'Status', sortable: false, type: 'string', component: (row) => row.status === 1 ? <p className='badge bg-label-success'>Active</p> : <p className='badge bg-label-danger'>Inactive</p> },
  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-delete',
    tooltip: 'Delete'
  },
  ],
  // recActive: true,
  // status: {
  //   key: 'status',
  //   active: '1',
  //   activeIcon: 'mdi mdi-checkbox-marked',
  //   inActiveIcon: 'mdi mdi-close-box',
  //   confirmation: true,
  //   activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
  //   inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  // },
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};

export const status = [
  {}
]

export const roStatus = [
  {
    statusID: 0,
    label: "All",
    value: 2,
    name: "status",
  },
  {
    statusID: 0,
    label: "Active",
    name: "status",
    value: 1,
  },
  {
    statusID: 0,
    label: "Inactive",
    value: 0,
    name: "status",
  },
];

export const mappedStatus = [
  {
    label: "All",
    value: 2,
    name: "mapStatus",
  },
  {
    label: "Yes",
    value: 1,
    name: "mapStatus",
  },
  {
    label: "No",
    value: 0,
    name: "mapStatus",
  },
];